
export default [
  {
    "ref": "emma",
    "name": "Emma",
    "avatar": "https://www.cremma.nl/assets/authors/emma.png",
    "content": "",
    "_meta": {
      "filePath": "authors/emma.mdx",
      "fileName": "emma.mdx",
      "directory": "authors",
      "extension": "mdx",
      "path": "authors/emma"
    }
  },
  {
    "ref": "erik-jan",
    "name": "Erik-Jan",
    "avatar": "https://www.cremma.nl/assets/authors/erik-jan.png",
    "content": "",
    "_meta": {
      "filePath": "authors/erik-jan.mdx",
      "fileName": "erik-jan.mdx",
      "directory": "authors",
      "extension": "mdx",
      "path": "authors/erik-jan"
    }
  }
]